import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getComponents } from "src/components/app/getComponents";
import HeroBanner from "src/components/app/homescreen/HeroBanner/HeroBanner";
import PoweredByLogo from "src/components/app/homescreen/PoweredByLogo";
import DocumentStatusCard from "src/components/app/review-state/DocumentStatusCard";
import ProgramDetailsCard from "src/components/app/review-state/ProgramDetailsCard";
import analytics from "src/helpers/analytics";
import { SCREEN_NAMES } from "src/helpers/analytics/events";
import { useAppSelector } from "src/redux/hooks";

interface ProgramScreenProps {
  screenData: any;
  supportProgramKey: any;
}

const ProgramScreen: React.FC<ProgramScreenProps> = ({
  screenData,
  supportProgramKey,
}) => {
  const navigate = useNavigate();
  const { patient } = useAppSelector((state) => state.auth);

  const heroBanner = screenData.components?.find(
    (component: any) => component.id === "hero-section"
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    // page view
    analytics.pageView(SCREEN_NAMES.PROGRAM_SCREEN);
  }, []);

  const paidUser = Number(patient?.data?.paidUser) === 1;

  if (!paidUser) {
    const poweredByLogo = screenData.components?.find(
      (component: any) => component.id === "powered-by-logo"
    );
    return (
      <>
        <HeroBanner {...heroBanner} supportProgramKey={supportProgramKey} />
        <DocumentStatusCard supportProgramKey={supportProgramKey} />
        <ProgramDetailsCard supportProgramKey={supportProgramKey} />
        <PoweredByLogo
          supportProgramKey={supportProgramKey}
          imageUrl={poweredByLogo.image_url}
        />
      </>
    );
  }

  return (
    <>
      {Array.isArray((screenData as any)?.components) &&
        (
          screenData as unknown as { components: { id: string }[] }
        ).components.map((component) => (
          <div key={component.id}>
            {getComponents(component, navigate, supportProgramKey)}
          </div>
        ))}
    </>
  );
};

export default ProgramScreen;
